import styles from "./favorites-skeleton.module.css";

export function FavoritesSkeleton() {
  const skeletonCount = 4;

  return (
    <div className={styles.grid} data-testid="favorites-skeleton">
      {Array.from({ length: skeletonCount }).map((_, index) => (
        <div className={styles.card} key={`skeleton-${index}`}>
          <div className={styles.imageWrapper}>
            <div className={styles.imagePlaceholder} />
          </div>
          <div className={styles.content}>
            <div className={styles.titlePlaceholder} />
            <div className={styles.subtitlePlaceholder} />
            <div className={styles.detailsRow}>
              <div className={styles.pricePlaceholder} />
              <div className={styles.smallPlaceholder} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
